<template>
  <div>
    <v-container>
      <v-row justify="center" justify-md="start" style="margin-bottom: 10px">
        <AppLink/>
      </v-row>

      <v-row justify="center" justify-md="start">
        <div class="d-flex align-center">
          <v-img src="../assets/icon.png" max-height="70" max-width="70" style="margin-right: 10px"/>

          <div class="d-flex flex-column">
            <div class="font-weight-medium">
              大学生に寄り添った時間割アプリ！
            </div>
            <div class="font-weight-bold display-1 d-none d-sm-none d-md-flex">
              大学生のための時間割
            </div>
            <div class="font-weight-bold headline d-flex d-sm-flex d-md-none">
              大学生のための時間割
            </div>
          </div>
        </div>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import AppLink from './AppLink'

export default {
  name: 'Title',
  components: { AppLink }
}
</script>

<style scoped>
</style>
